import classNames from 'classnames';
import React from 'react';
import Slider from 'react-slick';

import RefImage from '@jpp/atoms/Image';
import { IPdpImageGallery } from 'common/redux/pdp/reducer';
import { cleanArray, deDupeArrayOfObjects } from 'common/utils/shared';

import './external/slick-theme.scss';
import './external/slick.scss';
import './PDPCarousel.scss';

interface IPDPCarouselProps {
  className?: string;
  featuredImage?: Core.IMedia;
  image: Core.IMedia;
  gallery?: IPdpImageGallery[];
}

const ROOT_CLASSNAME = 'PDPCarousel';

const PDP_CAROUSEL_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const PDPCarousel: React.FunctionComponent<IPDPCarouselProps> = ({
  className,
  featuredImage,
  image: propImage,
  gallery: propGallery,
}) => {
  const gallery = propGallery?.length ? propGallery : [];
  const imageGallery: IPdpImageGallery[] =
    featuredImage || propImage
      ? [{ image: featuredImage || propImage }, ...gallery]
      : gallery;
  const imageWrapperClassNames = `${ROOT_CLASSNAME}__image-wrapper`;
  const imageClassNames = `${ROOT_CLASSNAME}__image`;
  const finalGallery = cleanArray(
    imageGallery?.map(({ image }) => image) || []
  );

  return (
    <Slider
      className={classNames(ROOT_CLASSNAME, className)}
      {...PDP_CAROUSEL_SETTINGS}
    >
      {deDupeArrayOfObjects(finalGallery, 'url')?.map((prodImage, index) => {
        if (!prodImage) {
          return null;
        }

        return (
          <div key={index} className={imageWrapperClassNames}>
            <RefImage className={imageClassNames} image={prodImage} />
          </div>
        );
      })}
    </Slider>
  );
};

export default PDPCarousel;
